<template>
  <div v-if="modal">
    <div class="modal is-active">
      <div class="modal-background"></div>
      <div class="modal-card is-small">
        <header class="modal-card-head has-text-centered header-with-inline-button">
          <p class="modal-card-title" v-if="message">Welcome</p>	
          <button class="delete" aria-label="close" @click="closeModal()"></button>
        </header>

        <section class="modal-card-body ph20 has-text-centered">

          <div class="text-center" v-if="signup_business_logo">
            <img :src="signup_business_logo" alt="" class="signup-modal-business-logo"/>
          </div>
          
          <div class="mb-20 p20 relative referal-point-notice" v-if="message">
            <div class="text-dark is-size-16px z-index-1 relative"  v-html="message">
            </div>
          </div>

           <div :class="'profile-option'+ ( message ? '' : ' mt20')">
              <a href="#" @click.prevent="showSignupModal()" class="button mb10 is-full-width bg-secondary text-white hover-opacity-7 is-medium">FIRST TIME</a>
              <a href="#" @click.prevent="showLoginModal()" class="button is-full-width is-transparent is-medium mb10">I ALREADY HAVE AN ACCOUNT</a>
              <p class="text-center is-size-11 mt10 text-primary"> 
                <span class="text-primary">POWERED BY </span> <img alt="logo" class="vertical-align-inherit powered-logo" src="@/assets/img/logo.png" />
              </p>
            </div>
        </section>
        <footer class="modal-card-foot">
        </footer>

      </div>
    </div>
  </div>
</template>

<script>
import Helpers from '@/Components/Helpers/Helpers';
import { mapGetters, mapActions } from "vuex";

export default {
  name: "SignupLoginOptionModal",
  components: {

  },
  data() {
    return {
     modal: false,
     message: '',
    };
  },

  computed: {
    ...mapGetters({
      vg_modal: "loginmodal/modal",
      vg_userId: "getLoggedInUserId",
      vg_businessProfile: "businessprofile/detail", 
      vg_businessLoyality: "businessprofile/businessLoyality",
    }),

    signup_business_logo() {
      // Show business loyalty logo if available else business logo
      if(!_.isEmpty(this.vg_businessLoyality)  && this.vg_businessLoyality.branding && this.vg_businessLoyality.branding.logo_url) {
        return this.vg_businessLoyality.branding.logo_url;
      } else if(!_.isEmpty(this.vg_businessProfile)  && this.vg_businessProfile.branding && this.vg_businessProfile.branding.logo_url) {
        return this.vg_businessProfile.branding.logo_url;
      } else {
        return '';
      }
    },
  },

  async mounted() {
    bus.$on('show-signup-login-option-modal', (payload) => {
      this.modal = payload.modal;
      this.message = payload.message;
    })
  },

  methods: {
     /**
     * Close Modal
     */
    closeModal() {
      this.modal = false;
    },
     /**
     * Sign up Modal
     */
    showSignupModal() {
      this.modal = false;
      this.va_setSignupModal(true);
    },
    /**
     * Login Modal
     */
    showLoginModal() {
      this.modal = false;
      this.va_setLoginModal(true);
    },
    ...mapActions({
      va_setSignupModal: "signupmodal/setModal",
      va_setLoginModal: "loginmodal/setModal",
    })
  }
};
</script>
<style scoped>
.header-with-inline-button button {
    position: absolute;
    right: 0;
    top: 25px;
    right: 19px;
}
</style>